<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="关联" name="first">
                <div class="mt10 mb10" style="overflow: hidden">
                    <div class="swb-btn swb-btn-small mr5 fr" @click="saveAdoptedDeviceRel">保存</div>
                </div>
                <swb-adopted-device-list-select :nxtActiveName="activeName" :catId="catId" :brandId="brandId" :fixedSpec="fixedSpec" :model="model" :centBuyMode="centBuyMode" :notAssetDefFlag="notAssetDefFlag" :skuFlag="skuFlag" :checkIds="checkIds" :filter="filter" :showTable="true" :showCatBrandTable="true" ref="swb_adopted_device_list_select"></swb-adopted-device-list-select>
            </el-tab-pane>
            <el-tab-pane label="查看" name="second">
                <swb-asmbl-acc-def-rel-device-list :activeName="activeName" :filter="showFilter" ref="swb_asmbl_acc_def_rel_device_list"></swb-asmbl-acc-def-rel-device-list>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    //
    import devcReqrApi from '../../api/devcReqr'
    //
    import SwbGoodsInSelect from '../retailer/GoodsInSelect'
    Vue.regist(SwbGoodsInSelect);

    import SwbAsmblAccDefRelDeviceList from '../asmblAcc/AsmblAccDefRelDeviceList';
    Vue.regist(SwbAsmblAccDefRelDeviceList);

    export default{
        name: 'swb-mercht-device-asset-set',
        avlScopes: 'retailer',
        desc: '资产定义-资产商品（关联 + 查看）',
        props: {
            checkIds: {
                type: Array,
                default: null
            },
            skuFlag: {
                type: Boolean,
                default: null,
            },
            centBuyMode: {
                type: Boolean,
                default: null,
            },
            filter: {
                type: Object,
                default: function () {

                },
            },
            catId: {
                type: Number,
                default: null
            },
            brandId: {
                type: Number,
                default: null
            },
            fixedSpec: {
                type: String,
                default: null
            },
            model: {
                type: String,
                default: null
            },
            asmblAccDefId: {
                type: Number,
                default: null
            },
            centBuyRequired: {
                type: Boolean,
                default: null,
            },
            // 查看的条件
            showFilter: {
                type: Object,
                default: function () {
                },
            },
            durableLife: {
                type: Number,
                default: null
            },
            asmblAccFlag: {
                type: Boolean,
                default: null,
            },
            innerCode: {
                type: String,
                default: null,
            },
            assetType: {
                type: Number,
                default: null,
            },
            notAssetDefFlag: {
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                activeName: 'first'
            }
        },
        created: function () {

        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            //
            saveAdoptedDeviceRel: function () {
                let self = this;
                let result = this.$refs.swb_adopted_device_list_select.getDlgResult() || {};
                if(result.type == 'info') {
                    let itemList = result.data || [];
                    let isOk = true;
                    if(self.durableLife != null) {
                        for(let i = 0; i < itemList.length; i++) {
                            if(itemList[i].wrntPeriod != self.durableLife) {
                                isOk = false;
                                break;
                            }
                        }
                    }
                    //
                    let ids = itemList.pluck('id');
                    //
                    if(isOk) {
                        this.doSave(ids);
                    } else {
                        this.$confirm('所选商品质保期与定义使用期限不一致,是否继续?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            self.doSave(ids);
                        }).catch(function () {

                        });
                    }
                } else {
                    MsgBox.warning(result.message);
                    return false;
                }
            },
            doSave(ids){
                let self = this;
                let postData = {};
                postData.asmblAccDefId = self.asmblAccDefId;
                postData.centBuyMode = self.centBuyRequired;
                postData.ids = ids;
                postData.asmblAccFlag = self.asmblAccFlag;
                postData.assetType = self.assetType;
                postData.innerCode = self.innerCode;
                devcReqrApi.doCheckAdoptedDeviceRelAssetDef(postData, function (result) {
                    if(result.type == "info") {
                        if(result.data != null) {
                            self.$confirm(result.data, '提示', {
                                confirmButtonText: '重新关联',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                self.doAdoptedDeviceRelDevcDef(postData);
                            }).catch(function () {
                            });
                        } else {
                            self.doAdoptedDeviceRelDevcDef(postData);
                        }
                    }
                })
            },
            doAdoptedDeviceRelDevcDef(postData){
                let self = this;
                let theLoad = MsgBox.loading();
                devcReqrApi.doAdoptedDeviceRelAsmblAcc(postData, function (result) {
                    if(result.type == "info") {
                        theLoad.hide();
                        MsgBox.success("操作成功!");
                        //
                        self.activeName = "second";
                    } else {
                        MsgBox.warning(result.message);
                        theLoad.hide();
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcAsset.vue